import { type GetDisputeCasesVariables } from '@repo/internal-tools-api/src/services/cases/DisputeCasesService.ts'
import { type EnumKey } from '@repo/internal-tools-type-utils/src/utils.ts'

export type CaseSortBy = NonNullable<GetDisputeCasesVariables>['sortBy']
export const CASE_SORT_BY = {
  CREATED_AT_UTC: 'CreatedAtUtc',
  DUE_AT_UTC: 'DueAtUtc',
  UPDATED_AT_UTC: 'UpdatedAtUtc',
} satisfies Record<EnumKey, CaseSortBy>
export const DEFAULT_CASE_SORT_BY = CASE_SORT_BY.CREATED_AT_UTC

export type CaseOrder = NonNullable<GetDisputeCasesVariables>['order']
export const CASE_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC',
} satisfies Record<EnumKey, CaseOrder>
export const DEFAULT_CASE_ORDER = CASE_ORDER.DESC
